import { Box, Button, Form } from '@arpeggi/ui'
import { FC } from 'react'
import Text from '../../__legacy__/components/core/Text/Text'
import { UrlTextInput } from './components/UrlTextInput'
import { useCreateRedirectForm } from './hooks/useCreateRedirectForm'
import { CreateRedirectForm } from './primitives'

export const CreateRedirect: FC = () => {
  const { form, onSubmit, createRedirectMutation } = useCreateRedirectForm()

  return (
    <CreateRedirectForm.Container>
      <Text size="24">Create new redirect</Text>
      {createRedirectMutation.error && <CreateRedirectForm.ApiAlert />}
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box column>
          <Form.FieldLabel>Redirect from</Form.FieldLabel>
          <UrlTextInput form={form} name="from" />
        </Box>
        <Box column>
          <Form.FieldLabel>To</Form.FieldLabel>
          <UrlTextInput form={form} name="to" />
        </Box>
        <Button type="submit" loading={createRedirectMutation.isLoading}>
          Save
        </Button>
      </form>
    </CreateRedirectForm.Container>
  )
}
